import { useEffect, useState } from "react";
import { hasWindow, off, on } from "cy-util";
import { useClientSide } from "./useClientSide";

const breakpointsMap = {
  "2xl": 1536,
  xl: 1280,
  lg: 1024,
  md: 768,
  sm: 640,
  "": 639, // this is needed because createBreakpoint treats everything under 640 as small whereas it hasnt hit the small breakpoint yet.
};

const sortedBreakpoints = Object.entries(breakpointsMap).sort((a, b) =>
  a[1] >= b[1] ? 1 : -1,
);

const useCurrentBreakpoint = () => {
  const [screenWidth, setScreenWidth] = useState(
    hasWindow() ? window.innerWidth : 0,
  );

  useEffect(() => {
    const setSideScreen = (): void => {
      setScreenWidth(window.innerWidth);
    };
    setSideScreen();
    on(window, "resize", setSideScreen);
    return () => {
      off(window, "resize", setSideScreen);
    };
  });

  const result = sortedBreakpoints.reduce((acc, [name, width]) => {
    if (screenWidth >= width) {
      return name;
    }
    return acc;
  }, sortedBreakpoints[0][0]);
  return result;
};

export type Breakpoint = "sm" | "md" | "lg" | "xl" | "2xl";
const breakpoints: Breakpoint[] = ["sm", "md", "lg", "xl", "2xl"];

/**
 * This might not be  SSR safe.
 *
 */
export function useBreakpoint() {
  const breakpoint = useCurrentBreakpoint() as Breakpoint | "";
  const breakpointIndex = breakpoints.indexOf(breakpoint as Breakpoint);
  const isClientSide = useClientSide();

  function hasMinWidth(bp: Breakpoint) {
    // This is to support SSR consistent default for client and server
    if (!isClientSide) return false;
    const index = breakpoints.indexOf(bp);
    return index <= breakpointIndex;
  }

  return { breakpoint, hasMinWidth };
}
